import React, { useState } from 'react'
import { useEffect } from 'react'
import { SelectIconButton } from '../common/Button'

import './index.sass'

export default function Monetization({handleMonetization}) {
    const [isFreeActive, setIsFreeActive] = useState(false)
    const [isPaidActive, setIsPaidActive] = useState(false)

    useEffect(()=>{
        handleMonetization(0)
        setIsFreeActive(true);
        setIsPaidActive(false)
    }, []);
    
    const handleFreeClicked = () => {
        setIsFreeActive(true)
        setIsPaidActive(false)
        handleMonetization(0)
    }

    const handlePaidClicked = () => {
        setIsFreeActive(false)
        setIsPaidActive(true)
        handleMonetization(1)
    }

    return (
        <div id="monetization">
            <div className="monetization-wrapper">
                <SelectIconButton
                    isActive={isFreeActive}
                    icon="free.svg"
                    activeIcon="free_a.svg"
                    text="Free"
                    description="Photo"
                    handleClick={handleFreeClicked}
                />
            </div>
            <div className="monetization-wrapper">
                <SelectIconButton
                    isActive={isPaidActive}
                    icon="paid.svg"
                    activeIcon="paid_a.svg"
                    text="Paid"
                    description="Photo"
                    handleClick={handlePaidClicked}
                />

            </div>

        </div>
    )
}
